export default [
    {
        path: '/',
        name: 'home',
        meta: {
            authentication_required: true,
            authorization_required: null
        },
        component: () => import('../views/layouts/main.vue'),
        children: [
            {
                path: '/subordinates',
                name: 'subordinates',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/users/subordinates-dashboard.vue')
            },
            {
                path: '/reports',
                name: 'reports',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/reports/dashboard.vue')
            },
            {
                path: '/partners/my-partners',
                name: 'my-partners',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/my.vue')
            },
            {
                path: '/partners/accessible-partners',
                name: 'accessible-partners',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/accessible.vue')
            },
            {
                path: '/partners/all',
                name: 'all-partner',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/all.vue')
            },
            {
                path: '/partners/free',
                name: 'free-partner',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/free.vue')
            },
            {
                path: '/partners/merge',
                name: 'merge-partner',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/merge.vue')
            },
            {
                path: '/partners/campaign',
                name: 'launch-campaign',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/partners/campaign.vue')
            },
            {
                path: '/partners/my-partners/create/:type?',
                name: 'my-partner-create',
                component: () => import('../views/pages/partners/partners/item.vue')
            },
            {
                path: '/partners/accessible-partners/create/:type?',
                name: 'accessible-partner-create',
                component: () => import('../views/pages/partners/partners/item.vue')
            },
            {
                path: '/partners/create/:type?',
                name: 'partner-create',
                component: () => import('../views/pages/partners/partners/item.vue')
            },
            {
                path: '/partners/:id(\\d+)/:type?',
                name: 'partner-edit',
                component: () => import('../views/pages/partners/partners/item.vue'),
                redirect: { name: 'partner-base-information'},
                children: [
                    {
                        path: '/partners/:id(\\d+)/projects/:type?',
                        name: 'partner-projects',
                        component: () => import('../views/pages/projects/partner.vue')
                    },
                    {
                        path: '/partners/:id(\\d+)/base-information/:type?',
                        name: 'partner-base-information',
                        component: () => import('../views/pages/partners/partners/edit.vue')
                    },
                    {
                        path: '/partners/:id(\\d+)/contacts/:type?',
                        name: 'partner-contacts',
                        component: () => import('../views/pages/partners/contacts/manage.vue')
                    },
                    {
                        path: '/partners/:id(\\d+)/decision-makers/:type?',
                        name: 'partner-decision-makers',
                        component: () => import('../views/pages/partners/decision-makers/manage.vue')
                    },
                    {
                        path: '/partners/:id(\\d+)/addresses/:type?',
                        name: 'partner-addresses',
                        component: () => import('../views/pages/partners/addresses/manage.vue')
                    },
                ]
            },
            {
                path: '/interactions/my-interactions',
                name: 'my-interactions',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/interactions/interactions/own.vue')
            },
            {
                path: '/interactions/my-meetings',
                name: 'interactions-my-meetings',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/own.vue')
            },
            {
                path: '/interactions/my-meetings/create',
                name: 'interactions-my-meeting-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: '/interactions/my-meetings/:id(\\d+)',
                name: 'interactions-my-meeting-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/item.vue'),
                props: { own: true, interaction: true },
            },
            {
                path: '/interactions/my-offers',
                name: 'interactions-my-offers',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/own.vue')
            },
            {
                path: '/interactions/my-offers/create',
                name: 'interactions-my-offer-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: '/interactions/my-offers/:id(\\d+)',
                name: 'interactions-my-offer-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/item.vue'),
                props: { own: true, interaction: true },
            },
            {
                path: '/interactions/my-contracts',
                name: 'interactions-my-contracts',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/own.vue')
            },
            {
                path: '/interactions/my-contracts/create',
                name: 'interactions-my-contract-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: '/interactions/my-contracts/:id(\\d+)',
                name: 'interactions-my-contract-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/item.vue'),
                props: { own: true, interaction: true },
            },
            {
                path: '/interactions/my-implements',
                name: 'interactions-my-implements',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/own.vue')
            },
            {
                path: '/interactions/my-implements/create',
                name: 'interactions-my-implement-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: '/interactions/my-implements/:id(\\d+)',
                name: 'interactions-my-implement-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/item.vue'),
                props: { own: true, interaction: true },
            },
            {
                path: '/interactions/my-invoices',
                name: 'interactions-interactions-my-invoices',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/own.vue'),
                props: { own: true, interaction: true },
            },
            {
                path: '/actions/:id(\\d+)',
                name: 'action-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/interactions/actions/item.vue')
            },
            /*{
                path: '/interactions/my-invoices/create',
                name: 'my-invoice-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/item.vue'),
                props: { own: true }
            },
            {
                path: '/interactions/my-invoices/:id(\\d+)',
                name: 'my-invoice-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/item.vue'),
                props: { own: true },
            },*/
            {
                path: '/projects/my-projects',
                name: 'my-projects',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/own.vue'),
                props: { own: true },
            },
            {
                path: '/projects/my-projects/create',
                name: 'my-project-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/item.vue'),
                props: { own: true }
            },
            {
                path: '/projects/my-projects/:id(\\d+)/commission',
                name: 'my-project-commission',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/commission.vue'),
                props: { own: true },
            },
            {
                path: '/projects/my-projects/:id(\\d+)',
                name: 'my-project-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/item.vue'),
                props: { own: true },
            },
            {
                path: '/projects/accessible-projects',
                name: 'accessible-projects',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/accessible.vue'),
            },
            {
                path: '/projects/accessible-projects/:id(\\d+)',
                name: 'accessible-project-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/projects/item.vue'),
            },
            {
                path: '/invoices/my-invoices',
                name: 'my-invoices',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/own.vue'),
                props: { own: true },
            },
            {
                path: '/invoices/my-invoices/create',
                name: 'my-invoice-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/item.vue'),
                props: { own: true }
            },
            {
                path: '/invoices/my-invoices/:id(\\d+)',
                name: 'my-invoice-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/item.vue'),
                props: { own: true },
            },
            {
                path: '/invoices/accessible-invoices',
                name: 'accessible-invoices',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/accessible.vue'),
            },
            {
                path: '/invoices/accessible-invoices/:id(\\d+)',
                name: 'accessible-invoice-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/invoices/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/meetings/my-meetings',
                name: 'my-meetings',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/own.vue'),
                props: { own: true },
            },
            {
                path: '/meetings/my-meetings/create',
                name: 'my-meeting-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/item.vue'),
                props: { own: true }
            },
            {
                path: '/meetings/my-meetings/:id(\\d+)',
                name: 'my-meeting-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/item.vue'),
                props: { own: true },
            },
            {
                path: '/meetings/accessible-meetings',
                name: 'accessible-meetings',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/accessible.vue'),
            },
            {
                path: '/meetings/accessible-meetings/:id(\\d+)',
                name: 'accessible-meeting-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/meetings/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/offers/my-offers',
                name: 'my-offers',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/own.vue'),
                props: { own: true },
            },
            {
                path: '/offers/my-offers/create',
                name: 'my-offer-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/item.vue'),
                props: { own: true }
            },
            {
                path: '/offers/my-offers/:id(\\d+)',
                name: 'my-offer-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/item.vue'),
                props: { own: true },
            },
            {
                path: '/offers/accessible-offers',
                name: 'accessible-offers',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/accessible.vue'),
            },
            {
                path: '/offers/accessible-offers/:id(\\d+)',
                name: 'accessible-offer-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/offers/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/contracts/my-contracts',
                name: 'my-contracts',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/own.vue'),
                props: { own: true },
            },
            {
                path: '/contracts/my-contracts/create',
                name: 'my-contract-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/item.vue'),
                props: { own: true }
            },
            {
                path: '/contracts/my-contracts/:id(\\d+)',
                name: 'my-contract-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/item.vue'),
                props: { own: true },
            },
            {
                path: '/contracts/accessible-contracts',
                name: 'accessible-contracts',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/accessible.vue'),
            },
            {
                path: '/contracts/accessible-contracts/:id(\\d+)',
                name: 'accessible-contract-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/contracts/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/implements/my-implements',
                name: 'my-implements',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/own.vue'),
                props: { own: true },
            },
            {
                path: '/implements/my-implements/create',
                name: 'my-implement-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/item.vue'),
                props: { own: true }
            },
            {
                path: '/implements/my-implements/:id(\\d+)',
                name: 'my-implement-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/item.vue'),
                props: { own: true },
            },
            {
                path: '/implements/accessible-implements',
                name: 'accessible-implements',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/accessible.vue'),
            },
            {
                path: '/implements/accessible-implements/:id(\\d+)',
                name: 'accessible-implement-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/implements/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/reminders/my-reminders',
                name: 'my-reminders',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/reminders/own.vue'),
                props: { own: true },
            },
            {
                path: '/reminders/my-reminders/create',
                name: 'my-reminder-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/reminders/item.vue'),
                props: { own: true }
            },
            {
                path: '/reminders/my-reminders/:id(\\d+)',
                name: 'my-reminder-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/reminders/item.vue'),
                props: { own: true },
            },
            {
                path: '/tasks/my-tasks',
                name: 'my-tasks',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/own.vue'),
                props: { own: true },
            },
            {
                path: '/tasks/my-tasks/create',
                name: 'my-task-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/item.vue'),
                props: { own: true }
            },
            {
                path: '/tasks/my-tasks/:id(\\d+)',
                name: 'my-task-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/item.vue'),
                props: { own: true },
            },
            {
                path: '/tasks/accessible-tasks',
                name: 'accessible-tasks',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/accessible.vue'),
            },
            {
                path: '/tasks/accessible-tasks/:id(\\d+)',
                name: 'accessible-task-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/tasks/accessible-tasks/create',
                name: 'accessible-task-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/tasks/tasks/item.vue'),
                props: { accessible: true },
            },
            {
                path: '/master-data/countries',
                name: 'countries',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/countries/list.vue')
            },
            {
                path: '/master-data/countries/create',
                name: 'country-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/countries/item.vue')
            },
            {
                path: '/master-data/countries/:id(\\d+)',
                name: 'country-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/countries/item.vue')
            },
            {
                path: '/master-data/zip-codes',
                name: 'zip-codes',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/zip-codes/list.vue')
            },
            {
                path: '/master-data/zip-codes/create',
                name: 'zip-code-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/zip-codes/item.vue')
            },
            {
                path: '/master-data/zip-codes/:id(\\d+)',
                name: 'zip-code-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/zip-codes/item.vue')
            },
            {
                path: '/master-data/street-types',
                name: 'street-types',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/street-types/list.vue')
            },
            {
                path: '/master-data/street-types/create',
                name: 'street-type-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/street-types/item.vue')
            },
            {
                path: '/master-data/street-types/:id(\\d+)',
                name: 'street-type-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/street-types/item.vue')
            },
            {
                path: '/master-data/positions',
                name: 'positions',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/positions/list.vue')
            },
            {
                path: '/master-data/positions/create',
                name: 'position-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/positions/item.vue')
            },
            {
                path: '/master-data/positions/:id(\\d+)',
                name: 'position-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/positions/item.vue')
            },
            {
                path: '/master-data/company-sizes',
                name: 'company-sizes',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/company-sizes/list.vue')
            },
            {
                path: '/master-data/company-sizes/create',
                name: 'company-size-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/company-sizes/item.vue')
            },
            {
                path: '/master-data/company-sizes/:id(\\d+)',
                name: 'company-size-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/company-sizes/item.vue')
            },
            {
                path: '/master-data/industries',
                name: 'industries',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/industries/list.vue')
            },
            {
                path: '/master-data/industries/create',
                name: 'industry-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/industries/item.vue')
            },
            {
                path: '/master-data/industries/:id(\\d+)',
                name: 'industry-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/partners/industries/item.vue')
            },
            {
                path: '/master-data/lead-sources',
                name: 'lead-sources',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/lead-sources/list.vue')
            },
            {
                path: '/master-data/lead-sources/create',
                name: 'lead-source-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/lead-sources/item.vue')
            },
            {
                path: '/master-data/lead-sources/:id(\\d+)',
                name: 'lead-source-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/lead-sources/item.vue')
            },
            {
                path: '/master-data/address-types',
                name: 'address-types',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/address-types/list.vue')
            },
            {
                path: '/master-data/address-types/create',
                name: 'address-type-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/address-types/item.vue')
            },
            {
                path: '/master-data/address-types/:id(\\d+)',
                name: 'address-type-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/address-types/item.vue')
            },
            {
                path: '/master-data/field-types',
                name: 'field-types',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/field-types/list.vue')
            },
            {
                path: '/master-data/field-types/create',
                name: 'field-type-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/field-types/item.vue')
            },
            {
                path: '/master-data/field-types/:id(\\d+)',
                name: 'field-type-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/field-types/item.vue')
            },
            {
                path: '/master-data/additional-data/:type?',
                name: 'additional-data',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/additional-data/manager.vue')
            },
            {
                path: '/master-data/additional-data/create/:type?',
                name: 'additional-data-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/additional-data/item.vue')
            },
            {
                path: '/master-data/additional-data/:id(\\d+)/:type?',
                name: 'additional-data-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/additional-data/item.vue')
            },
            {
                path: '/system',
                name: 'system',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                }
            },
            {
                path: '/authorization/permissions',
                name: 'roles',
                meta: {
                    authentication_required: true,
                    authorization_required: 'roles.view'
                },
                component: () => import('../views/pages/roles/list.vue')
            },
            {
                path: '/authorization/permissions/create',
                name: 'role-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'roles.create'
                },
                component: () => import('../views/pages/roles/item.vue')
            },
            {
                path: '/authorization/permissions/:id(\\d+)',
                name: 'role-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'roles.update'
                },
                component: () => import('../views/pages/roles/item.vue')
            },
            {
                path: '/authorization/role-groups',
                name: 'role-groups',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_groups.view'
                },
                component: () => import('../views/pages/role-groups/list.vue')
            },
            {
                path: '/authorization/role-groups/create',
                name: 'role-group-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_groups.create'
                },
                component: () => import('../views/pages/role-groups/item.vue')
            },
            {
                path: '/authorization/role-groups/:id(\\d+)',
                name: 'role-group-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_groups.update'
                },
                component: () => import('../views/pages/role-groups/item.vue')
            },
            {
                path: '/authorization/role-categories',
                name: 'role-categories',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_categories.view'
                },
                component: () => import('../views/pages/role-categories/list.vue')
            },
            {
                path: '/authorization/role-categories/create',
                name: 'role-category-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_categories.create'
                },
                component: () => import('../views/pages/role-categories/item.vue')
            },
            {
                path: '/authorization/role-categories/:id(\\d+)',
                name: 'role-category-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'role_categories.update'
                },
                component: () => import('../views/pages/role-categories/item.vue')
            },
            {
                path: '/authorization/modules',
                name: 'modules',
                meta: {
                    authentication_required: true,
                    authorization_required: 'modules.view'
                },
                component: () => import('../views/pages/modules/list.vue')
            },
            {
                path: '/authorization/modules/create',
                name: 'module-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'modules.create'
                },
                component: () => import('../views/pages/modules/item.vue')
            },
            {
                path: '/authorization/modules/:id(\\d+)',
                name: 'module-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'modules.update'
                },
                component: () => import('../views/pages/modules/item.vue')
            },
            {
                path: '/authorization/individuals',
                name: 'individuals',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/authorization/matrix.vue')
            },
            {
                path: '/authorization/individual/role-group',
                name: 'individual-role-group',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/authorization/grant-group.vue')
            },
            {
                path: '/users',
                name: 'users',
                meta: {
                    authentication_required: true,
                    authorization_required: 'users.view'
                },
                component: () => import('../views/pages/users/list.vue')
            },
            {
                path: '/users/create',
                name: 'user-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'users.create'
                },
                component: () => import('../views/pages/users/item.vue')
            },
            {
                path: '/users/:id(\\d+)',
                name: 'user-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'users.update',
                    available_for_superior: true
                },
                component: () => import('../views/pages/users/item.vue')
            },
            {
                path: '/users/profile',
                name: 'users-profile',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/users/profile-edit.vue')
            },
            {
                path: '/profiles/:id(\\d+)',
                name: 'public-profile',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/users/public-profile.vue')
            },
            {
                path: '/users/microsoft-graph',
                name: 'users-microsoft-graph',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/users/microsoft.vue')
            },
            {
                path: '/users/google-api',
                name: 'users-google-api',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/users/google.vue')
            },
            {
                path: '/api-accounts',
                name: 'api-accounts',
                component: () => import('../views/pages/accounts/list.vue')
            },
            {
                path: '/api-accounts/create',
                name: 'api-account-create',
                component: () => import('../views/pages/accounts/item.vue')
            },
            {
                path: '/api-accounts/:id(\\d+)',
                name: 'api-account-edit',
                component: () => import('../views/pages/accounts/item.vue')
            },
            {
                path: '/menu-system/menus',
                name: 'menus',
                component: () => import('../views/pages/menus/list.vue')
            },
            {
                path: '/menu-system/menus/create',
                name: 'menu-create',
                component: () => import('../views/pages/menus/item.vue')
            },
            {
                path: '/menu-system/menus/:id(\\d+)',
                name: 'menu-edit',
                component: () => import('../views/pages/menus/item.vue')
            },
            {
                path: '/menu-system/menu-point-categories',
                name: 'menu-point-categories',
                component: () => import('../views/pages/menu-point-categories/list.vue')
            },
            {
                path: '/menu-system/menu-point-categories/create',
                name: 'menu-point-category-create',
                component: () => import('../views/pages/menu-point-categories/item.vue')
            },
            {
                path: '/menu-system/menu-point-categories/:id(\\d+)',
                name: 'menu-point-category-edit',
                component: () => import('../views/pages/menu-point-categories/item.vue')
            },
            {
                path: '/menu-system/menu-points',
                name: 'menu-points',
                component: () => import('../views/pages/menu-points/list.vue')
            },
            {
                path: '/menu-system/menu-points/create',
                name: 'menu-point-create',
                component: () => import('../views/pages/menu-points/item.vue')
            },
            {
                path: '/menu-system/menu-points/:id(\\d+)',
                name: 'menu-point-edit',
                component: () => import('../views/pages/menu-points/item.vue')
            },
            {
                path: '/files/:path*',
                name: 'file',
                component: () => import('../views/pages/files/item.vue')
            },
            {
                path: '/master-data/priorities',
                name: 'priorities',
                component: () => import('../views/pages/priorities/list.vue')
            },
            {
                path: '/master-data/priorities/create',
                name: 'priority-create',
                component: () => import('../views/pages/priorities/item.vue')
            },
            {
                path: '/master-data/priorities/:id(\\d+)',
                name: 'priority-edit',
                component: () => import('../views/pages/priorities/item.vue')
            },
            {
                path: '/master-data/statuses',
                name: 'statuses',
                component: () => import('../views/pages/statuses/list.vue')
            },
            {
                path: '/master-data/statuses/create',
                name: 'status-create',
                component: () => import('../views/pages/statuses/item.vue')
            },
            {
                path: '/master-data/statuses/:id(\\d+)',
                name: 'status-edit',
                component: () => import('../views/pages/statuses/item.vue')
            },
            {
                path: '/master-data/billable-categories',
                name: 'billable-categories',
                component: () => import('../views/pages/billable-categories/list.vue')
            },
            {
                path: '/master-data/billable-categories/create',
                name: 'billable-category-create',
                component: () => import('../views/pages/billable-categories/item.vue')
            },
            {
                path: '/master-data/billable-categories/:id(\\d+)',
                name: 'billable-category-edit',
                component: () => import('../views/pages/billable-categories/item.vue')
            },
            {
                path: '/master-data/contract-types',
                name: 'contract-types',
                component: () => import('../views/pages/contract-types/list.vue')
            },
            {
                path: '/master-data/contract-types/create',
                name: 'contract-type-create',
                component: () => import('../views/pages/contract-types/item.vue')
            },
            {
                path: '/master-data/contract-types/:id(\\d+)',
                name: 'contract-type-edit',
                component: () => import('../views/pages/contract-types/item.vue')
            },
            {
                path: '/master-data/target-value-types',
                name: 'target-value-types',
                component: () => import('../views/pages/crm/target-value-types/list.vue')
            },
            {
                path: '/master-data/target-value-types/create',
                name: 'target-value-type-create',
                component: () => import('../views/pages/crm/target-value-types/item.vue')
            },
            {
                path: '/master-data/target-value-types/:id(\\d+)',
                name: 'target-value-type-edit',
                component: () => import('../views/pages/crm/target-value-types/item.vue')
            },
            {
                path: '/master-data/acquisitions',
                name: 'acquisitions',
                component: () => import('../views/pages/partners/acquisitions/list.vue')
            },
            {
                path: '/master-data/acquisitions/create',
                name: 'acquisition-create',
                component: () => import('../views/pages/partners/acquisitions/item.vue')
            },
            {
                path: '/master-data/acquisitions/:id(\\d+)',
                name: 'acquisition-edit',
                component: () => import('../views/pages/partners/acquisitions/item.vue')
            },
            {
                path: '/master-data/partner-sources',
                name: 'partner-sources',
                component: () => import('../views/pages/partners/sources/list.vue')
            },
            {
                path: '/master-data/partner-sources/create',
                name: 'partner-source-create',
                component: () => import('../views/pages/partners/sources/item.vue')
            },
            {
                path: '/master-data/partner-sources/:id(\\d+)',
                name: 'partner-source-edit',
                component: () => import('../views/pages/partners/sources/item.vue')
            },
            {
                path: '/master-data/project-sources',
                name: 'project-sources',
                component: () => import('../views/pages/crm/sources/list.vue')
            },
            {
                path: '/master-data/project-sources/create',
                name: 'project-source-create',
                component: () => import('../views/pages/crm/sources/item.vue')
            },
            {
                path: '/master-data/project-sources/:id(\\d+)',
                name: 'project-source-edit',
                component: () => import('../views/pages/crm/sources/item.vue')
            },
            {
                path: '/master-data/project-types',
                name: 'project-types',
                component: () => import('../views/pages/crm/project-types/list.vue')
            },
            {
                path: '/master-data/project-types/create',
                name: 'project-type-create',
                component: () => import('../views/pages/crm/project-types/item.vue')
            },
            {
                path: '/master-data/project-types/:id(\\d+)',
                name: 'project-type-edit',
                component: () => import('../views/pages/crm/project-types/item.vue')
            },
            {
                path: '/master-data/implementers',
                name: 'implementers',
                component: () => import('../views/pages/implementers/list.vue')
            },
            {
                path: '/master-data/implementers/create',
                name: 'implementer-create',
                component: () => import('../views/pages/implementers/item.vue')
            },
            {
                path: '/master-data/implementers/:id(\\d+)',
                name: 'implementer-edit',
                component: () => import('../views/pages/implementers/item.vue')
            },
            {
                path: '/master-data/products',
                name: 'products',
                component: () => import('../views/pages/products/list.vue')
            },
            {
                path: '/master-data/products/create',
                name: 'product-create',
                component: () => import('../views/pages/products/item.vue')
            },
            {
                path: '/master-data/products/:id(\\d+)',
                name: 'product-edit',
                component: () => import('../views/pages/products/item.vue')
            },
            {
                path: '/master-data/services',
                name: 'services',
                component: () => import('../views/pages/services/list.vue')
            },
            {
                path: '/master-data/services/create',
                name: 'service-create',
                component: () => import('../views/pages/services/item.vue')
            },
            {
                path: '/master-data/services/:id(\\d+)',
                name: 'service-edit',
                component: () => import('../views/pages/services/item.vue')
            },
            {
                path: '/master-data/processes',
                name: 'processes',
                component: () => import('../views/pages/processes/list.vue')
            },
            {
                path: '/master-data/processes/create',
                name: 'process-create',
                component: () => import('../views/pages/processes/item.vue')
            },
            {
                path: '/master-data/processes/:id(\\d+)',
                name: 'process-edit',
                component: () => import('../views/pages/processes/item.vue')
            },
            {
                path: '/master-data/interactions',
                name: 'interactions',
                component: () => import('../views/pages/interactions/interactions/list.vue')
            },
            {
                path: '/master-data/interactions/create',
                name: 'interaction-create',
                component: () => import('../views/pages/interactions/interactions/item.vue')
            },
            {
                path: '/master-data/interactions/:id(\\d+)',
                name: 'interaction-edit',
                component: () => import('../views/pages/interactions/interactions/item.vue')
            },
            {
                path: '/master-data/interaction-groupings',
                name: 'interaction-groupings',
                component: () => import('../views/pages/interactions/groupings/list.vue')
            },
            {
                path: '/master-data/interaction-groupings/create',
                name: 'interaction-grouping-create',
                component: () => import('../views/pages/interactions/groupings/item.vue')
            },
            {
                path: '/master-data/interaction-groupings/:id(\\d+)',
                name: 'interaction-grouping-edit',
                component: () => import('../views/pages/interactions/groupings/item.vue')
            },
            {
                path: '/master-data/interaction-categories',
                name: 'interaction-categories',
                component: () => import('../views/pages/interactions/categories/list.vue')
            },
            {
                path: '/master-data/interaction-categories/create',
                name: 'interaction-category-create',
                component: () => import('../views/pages/interactions/categories/item.vue')
            },
            {
                path: '/master-data/interaction-categories/:id(\\d+)',
                name: 'interaction-category-edit',
                component: () => import('../views/pages/interactions/categories/item.vue')
            },
            {
                path: '/master-data/tasks/types',
                name: 'tasks-types',
                component: () => import('../views/pages/tasks/types/list.vue')
            },
            {
                path: '/master-data/tasks/types/create',
                name: 'tasks-type-create',
                component: () => import('../views/pages/tasks/types/item.vue')
            },
            {
                path: '/master-data/tasks/types/:id(\\d+)',
                name: 'tasks-type-edit',
                component: () => import('../views/pages/tasks/types/item.vue')
            },
            {
                path: '/master-data/tasks/priorities',
                name: 'tasks-priorities',
                component: () => import('../views/pages/tasks/priorities/list.vue')
            },
            {
                path: '/master-data/tasks/priorities/create',
                name: 'tasks-priority-create',
                component: () => import('../views/pages/tasks/priorities/item.vue')
            },
            {
                path: '/master-data/tasks/priorities/:id(\\d+)',
                name: 'tasks-priority-edit',
                component: () => import('../views/pages/tasks/priorities/item.vue')
            },
            {
                path: '/master-data/tasks/statuses',
                name: 'tasks-statuses',
                component: () => import('../views/pages/tasks/statuses/list.vue')
            },
            {
                path: '/master-data/tasks/statuses/create',
                name: 'tasks-status-create',
                component: () => import('../views/pages/tasks/statuses/item.vue')
            },
            {
                path: '/master-data/tasks/statuses/:id(\\d+)',
                name: 'tasks-status-edit',
                component: () => import('../views/pages/tasks/statuses/item.vue')
            },
            {
                path: '/master-data/tasks/templates',
                name: 'tasks-templates',
                component: () => import('../views/pages/tasks/templates/list.vue')
            },
            {
                path: '/master-data/tasks/templates/create',
                name: 'tasks-template-create',
                component: () => import('../views/pages/tasks/templates/item.vue')
            },
            {
                path: '/master-data/tasks/templates/:id(\\d+)',
                name: 'tasks-template-edit',
                component: () => import('../views/pages/tasks/templates/item.vue')
            },
            {
                path: '/master-data/tasks/tasks',
                name: 'tasks-tasks',
                component: () => import('../views/pages/tasks/tasks/list.vue')
            },
            {
                path: '/master-data/tasks/tasks/create',
                name: 'tasks-task-create',
                component: () => import('../views/pages/tasks/tasks/item.vue')
            },
            {
                path: '/master-data/tasks/tasks/:id(\\d+)',
                name: 'tasks-task-edit',
                component: () => import('../views/pages/tasks/tasks/item.vue')
            },
            {
                path: '/master-data/tasks/tasks/alt/:id(\\d+)',
                name: 'tasks-task-edit-alt',
                component: () => import('../views/pages/tasks/tasks/item-alt.vue')
            },
            {
                path: '/master-data/invoices/currencies',
                name: 'invoices-currencies',
                component: () => import('../views/pages/currencies/list.vue')
            },
            {
                path: '/master-data/invoices/currencies/create',
                name: 'invoices-currency-create',
                component: () => import('../views/pages/currencies/item.vue')
            },
            {
                path: '/master-data/invoices/currencies/:id(\\d+)',
                name: 'invoices-currency-edit',
                component: () => import('../views/pages/currencies/item.vue')
            },
            {
                path: '/master-data/invoices/vats',
                name: 'invoices-vats',
                component: () => import('../views/pages/vats/list.vue')
            },
            {
                path: '/master-data/invoices/vats/create',
                name: 'invoices-vat-create',
                component: () => import('../views/pages/vats/item.vue')
            },
            {
                path: '/master-data/invoices/vats/:id(\\d+)',
                name: 'invoices-vat-edit',
                component: () => import('../views/pages/vats/item.vue')
            },
            {
                path: '/master-data/invoices/invoice-types',
                name: 'invoices-invoice-types',
                component: () => import('../views/pages/invoice-types/list.vue')
            },
            {
                path: '/master-data/invoices/invoice-types/create',
                name: 'invoices-invoice-type-create',
                component: () => import('../views/pages/invoice-types/item.vue')
            },
            {
                path: '/master-data/invoices/invoice-types/:id(\\d+)',
                name: 'invoices-invoice-type-edit',
                component: () => import('../views/pages/invoice-types/item.vue')
            },
            {
                path: '/master-data/invoices/units',
                name: 'invoices-units',
                component: () => import('../views/pages/units/list.vue')
            },
            {
                path: '/master-data/invoices/units/create',
                name: 'invoices-unit-create',
                component: () => import('../views/pages/units/item.vue')
            },
            {
                path: '/master-data/invoices/units/:id(\\d+)',
                name: 'invoices-unit-edit',
                component: () => import('../views/pages/units/item.vue')
            },
            {
                path: '/master-data/organizations/genders',
                name: 'genders',
                component: () => import('../views/pages/genders/list.vue')
            },
            {
                path: '/master-data/organizations/genders/create',
                name: 'gender-create',
                component: () => import('../views/pages/genders/item.vue')
            },
            {
                path: '/master-data/organizations/genders/:id(\\d+)',
                name: 'gender-edit',
                component: () => import('../views/pages/genders/item.vue')
            },
            {
                path: '/master-data/organizations/divisions',
                name: 'divisions',
                component: () => import('../views/pages/organization/divisions/list.vue')
            },
            {
                path: '/master-data/organizations/divisions/create',
                name: 'division-create',
                component: () => import('../views/pages/organization/divisions/item.vue')
            },
            {
                path: '/master-data/organizations/divisions/:id(\\d+)',
                name: 'division-edit',
                component: () => import('../views/pages/organization/divisions/item.vue')
            },
            {
                path: '/master-data/organizations/departments',
                name: 'departments',
                component: () => import('../views/pages/organization/departments/list.vue')
            },
            {
                path: '/master-data/organizations/departments/create',
                name: 'department-create',
                component: () => import('../views/pages/organization/departments/item.vue')
            },
            {
                path: '/master-data/organizations/departments/:id(\\d+)',
                name: 'department-edit',
                component: () => import('../views/pages/organization/departments/item.vue')
            },
            {
                path: '/master-data/organizations/hierarchy-levels',
                name: 'hierarchy-levels',
                component: () => import('../views/pages/organization/hierarchy-levels/list.vue')
            },
            {
                path: '/master-data/organizations/hierarchy-levels/create',
                name: 'hierarchy-level-create',
                component: () => import('../views/pages/organization/hierarchy-levels/item.vue')
            },
            {
                path: '/master-data/organizations/hierarchy-levels/:id(\\d+)',
                name: 'hierarchy-level-edit',
                component: () => import('../views/pages/organization/hierarchy-levels/item.vue')
            },
            {
                path: '/master-data/organizations/hierarchical-chains',
                name: 'hierarchical-chains',
                component: () => import('../views/pages/organization/hierarchical-chains/list.vue')
            },
            {
                path: '/master-data/organizations/hierarchical-chains/create',
                name: 'hierarchical-chain-create',
                component: () => import('../views/pages/organization/hierarchical-chains/item.vue')
            },
            {
                path: '/master-data/organizations/hierarchical-chains/:id(\\d+)',
                name: 'hierarchical-chain-edit',
                component: () => import('../views/pages/organization/hierarchical-chains/item.vue')
            },
            {
                path: '/master-data/organizations/knowledge-levels',
                name: 'knowledge-levels',
                component: () => import('../views/pages/organization/knowledge-levels/list.vue')
            },
            {
                path: '/master-data/organizations/knowledge-levels/create',
                name: 'knowledge-level-create',
                component: () => import('../views/pages/organization/knowledge-levels/item.vue')
            },
            {
                path: '/master-data/organizations/knowledge-levels/:id(\\d+)',
                name: 'knowledge-level-edit',
                component: () => import('../views/pages/organization/knowledge-levels/item.vue')
            },
            {
                path: '/master-data/organizations/locations',
                name: 'locations',
                component: () => import('../views/pages/organization/locations/list.vue')
            },
            {
                path: '/master-data/organizations/locations/create',
                name: 'location-create',
                component: () => import('../views/pages/organization/locations/item.vue')
            },
            {
                path: '/master-data/organizations/locations/:id(\\d+)',
                name: 'location-edit',
                component: () => import('../views/pages/organization/locations/item.vue')
            },
            {
                path: '/master-data/organizations/positions',
                name: 'org-positions',
                component: () => import('../views/pages/organization/positions/list.vue')
            },
            {
                path: '/master-data/organizations/positions/create',
                name: 'org-position-create',
                component: () => import('../views/pages/organization/positions/item.vue')
            },
            {
                path: '/master-data/organizations/positions/:id(\\d+)',
                name: 'org-position-edit',
                component: () => import('../views/pages/organization/positions/item.vue')
            },
            {
                path: '/master-data/organizations/skills',
                name: 'skills',
                component: () => import('../views/pages/organization/skills/list.vue')
            },
            {
                path: '/master-data/organizations/skills/create',
                name: 'skill-create',
                component: () => import('../views/pages/organization/skills/item.vue')
            },
            {
                path: '/master-data/organizations/skills/:id(\\d+)',
                name: 'skill-edit',
                component: () => import('../views/pages/organization/skills/item.vue')
            },
            {
                path: '/master-data/organizations/skill-levels',
                name: 'skill-levels',
                component: () => import('../views/pages/organization/skill-levels/list.vue')
            },
            {
                path: '/master-data/organizations/skill-levels/create',
                name: 'skill-level-create',
                component: () => import('../views/pages/organization/skill-levels/item.vue')
            },
            {
                path: '/master-data/organizations/skill-levels/:id(\\d+)',
                name: 'skill-level-edit',
                component: () => import('../views/pages/organization/skill-levels/item.vue')
            },
            {
                path: '/master-data/organizations/skill-types',
                name: 'skill-types',
                component: () => import('../views/pages/organization/skill-types/list.vue')
            },
            {
                path: '/master-data/organizations/skill-types/create',
                name: 'skill-type-create',
                component: () => import('../views/pages/organization/skill-types/item.vue')
            },
            {
                path: '/master-data/organizations/skill-types/:id(\\d+)',
                name: 'skill-type-edit',
                component: () => import('../views/pages/organization/skill-types/item.vue')
            },
            {
                path: '/master-data/organizations/specializations',
                name: 'specializations',
                component: () => import('../views/pages/organization/specializations/list.vue')
            },
            {
                path: '/master-data/organizations/specializations/create',
                name: 'specialization-create',
                component: () => import('../views/pages/organization/specializations/item.vue')
            },
            {
                path: '/master-data/organizations/specializations/:id(\\d+)',
                name: 'specialization-edit',
                component: () => import('../views/pages/organization/specializations/item.vue')
            },
            {
                path: '/master-data/organizations/teams',
                name: 'teams',
                component: () => import('../views/pages/organization/teams/list.vue')
            },
            {
                path: '/master-data/organizations/teams/create',
                name: 'team-create',
                component: () => import('../views/pages/organization/teams/item.vue')
            },
            {
                path: '/master-data/organizations/teams/:id(\\d+)',
                name: 'team-edit',
                component: () => import('../views/pages/organization/teams/item.vue')
            },
            {
                path: '/master-data/organizations/organization-statuses',
                name: 'organization-statuses',
                component: () => import('../views/pages/organization/organization-statuses/list.vue')
            },
            {
                path: '/master-data/organizations/organization-statuses/create',
                name: 'organization-status-create',
                component: () => import('../views/pages/organization/organization-statuses/item.vue')
            },
            {
                path: '/master-data/organizations/organization-statuses/:id(\\d+)',
                name: 'organization-status-edit',
                component: () => import('../views/pages/organization/organization-statuses/item.vue')
            },
            {
                path: '/master-data/organizations/sizes',
                name: 'organization-sizes',
                component: () => import('../views/pages/organization/sizes/list.vue')
            },
            {
                path: '/master-data/organizations/sizes/create',
                name: 'organization-size-create',
                component: () => import('../views/pages/organization/sizes/item.vue')
            },
            {
                path: '/master-data/organizations/sizes/:id(\\d+)',
                name: 'organization-size-edit',
                component: () => import('../views/pages/organization/sizes/item.vue')
            },
            {
                path: '/master-data/organizations/industries',
                name: 'organization-industries',
                component: () => import('../views/pages/organization/industries/list.vue')
            },
            {
                path: '/master-data/organizations/industries/create',
                name: 'organization-industry-create',
                component: () => import('../views/pages/organization/industries/item.vue')
            },
            {
                path: '/master-data/organizations/industries/:id(\\d+)',
                name: 'organization-industry-edit',
                component: () => import('../views/pages/organization/industries/item.vue')
            },
            {
                path: '/master-data/organizations/organization-types',
                name: 'organization-types',
                component: () => import('../views/pages/organization/organization-types/list.vue')
            },
            {
                path: '/master-data/organizations/organization-types/create',
                name: 'organization-type-create',
                component: () => import('../views/pages/organization/organization-types/item.vue')
            },
            {
                path: '/master-data/organizations/organization-types/:id(\\d+)',
                name: 'organization-type-edit',
                component: () => import('../views/pages/organization/organization-types/item.vue')
            },
            {
                path: '/master-data/organizations/ownership-types',
                name: 'ownership-types',
                component: () => import('../views/pages/organization/ownership-types/list.vue')
            },
            {
                path: '/master-data/organizations/ownership-types/create',
                name: 'ownership-type-create',
                component: () => import('../views/pages/organization/ownership-types/item.vue')
            },
            {
                path: '/master-data/organizations/ownership-types/:id(\\d+)',
                name: 'ownership-type-edit',
                component: () => import('../views/pages/organization/ownership-types/item.vue')
            },
            {
                path: '/master-data/organizations/governance-models',
                name: 'organization-governance-models',
                component: () => import('../views/pages/organization/governance-models/list.vue')
            },
            {
                path: '/master-data/organizations/governance-models/create',
                name: 'organization-governance-model-create',
                component: () => import('../views/pages/organization/governance-models/item.vue')
            },
            {
                path: '/master-data/organizations/governance-models/:id(\\d+)',
                name: 'organization-governance-model-edit',
                component: () => import('../views/pages/organization/governance-models/item.vue')
            },
            {
                path: '/master-data/newsletters/statuses',
                name: 'newsletters-statuses',
                component: () => import('../views/pages/newsletters/statuses/list.vue')
            },
            {
                path: '/master-data/newsletters/statuses/create',
                name: 'newsletters-status-create',
                component: () => import('../views/pages/newsletters/statuses/item.vue')
            },
            {
                path: '/master-data/newsletters/statuses/:id(\\d+)',
                name: 'newsletters-status-edit',
                component: () => import('../views/pages/newsletters/statuses/item.vue')
            },
            {
                path: '/master-data/newsletters/priorities',
                name: 'newsletters-priorities',
                component: () => import('../views/pages/newsletters/priorities/list.vue')
            },
            {
                path: '/master-data/newsletters/priorities/create',
                name: 'newsletters-priority-create',
                component: () => import('../views/pages/newsletters/priorities/item.vue')
            },
            {
                path: '/master-data/newsletters/priorities/:id(\\d+)',
                name: 'newsletters-priority-edit',
                component: () => import('../views/pages/newsletters/priorities/item.vue')
            },
            {
                path: '/master-data/newsletters/signatures',
                name: 'newsletters-signatures',
                component: () => import('../views/pages/newsletters/signatures/list.vue')
            },
            {
                path: '/master-data/newsletters/signatures/create',
                name: 'newsletters-signature-create',
                component: () => import('../views/pages/newsletters/signatures/item.vue')
            },
            {
                path: '/master-data/newsletters/signatures/:id(\\d+)',
                name: 'newsletters-signature-edit',
                component: () => import('../views/pages/newsletters/signatures/item.vue')
            },
            {
                path: '/master-data/newsletters/templates',
                name: 'newsletters-templates',
                component: () => import('../views/pages/newsletters/templates/list.vue')
            },
            {
                path: '/master-data/newsletters/templates/create',
                name: 'newsletters-template-create',
                component: () => import('../views/pages/newsletters/templates/item.vue')
            },
            {
                path: '/master-data/newsletters/templates/:id(\\d+)',
                name: 'newsletters-template-edit',
                component: () => import('../views/pages/newsletters/templates/item.vue')
            },
            {
                path: '/master-data/newsletters/periods',
                name: 'newsletters-periods',
                component: () => import('../views/pages/newsletters/periods/list.vue')
            },
            {
                path: '/master-data/newsletters/periods/create',
                name: 'newsletters-period-create',
                component: () => import('../views/pages/newsletters/periods/item.vue')
            },
            {
                path: '/master-data/newsletters/periods/:id(\\d+)',
                name: 'newsletters-period-edit',
                component: () => import('../views/pages/newsletters/periods/item.vue')
            },
            {
                path: '/resource-monitor',
                name: 'system-resource-monitor',
                component: () => import('../views/pages/system/resource-monitor.vue')
            },
            {
                path: '/contributors',
                name: 'contributors',
                meta: {
                    authentication_required: true,
                    authorization_required: 'contributors.view'
                },
                component: () => import('../views/pages/contributors/list.vue')
            },
            {
                path: '/contributors/create',
                name: 'contributor-create',
                meta: {
                    authentication_required: true,
                    authorization_required: 'contributors.create'
                },
                component: () => import('../views/pages/contributors/item.vue')
            },
            {
                path: '/contributors/:id(\\d+)',
                name: 'contributor-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: 'contributors.update'
                },
                component: () => import('../views/pages/contributors/item.vue')
            },
            {
                path: '/newsletters/my-newsletters',
                name: 'my-newsletters',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/list.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/create',
                name: 'newsletter-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
            },
            {
                path: '/newsletters/:id(\\d+)',
                name: 'newsletter-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
            },
            {
                path: '/newsletters/my-newsletters/create',
                name: 'my-newsletter-create',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-newsletters/:id(\\d+)',
                name: 'my-newsletter-edit',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: true },
            },
            {
                path: '/newsletters/my-mail-lists',
                name: 'newsletters-my-mail-lists',
                component: () => import('../views/pages/newsletters/mail-lists/list.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-mail-lists/create',
                name: 'newsletters-my-mail-list-create',
                component: () => import('../views/pages/newsletters/mail-lists/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-mail-lists/:id(\\d+)',
                name: 'newsletters-my-mail-list-edit',
                component: () => import('../views/pages/newsletters/mail-lists/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-filters',
                name: 'newsletters-my-filters',
                component: () => import('../views/pages/newsletters/filters/list.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-filters/create',
                name: 'newsletters-my-filter-create',
                component: () => import('../views/pages/newsletters/filters/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-filters/:id(\\d+)',
                name: 'newsletters-my-filter-edit',
                component: () => import('../views/pages/newsletters/filters/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-periodicals',
                name: 'newsletters-my-periodicals',
                component: () => import('../views/pages/newsletters/periodicals/list.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-periodicals/create',
                name: 'newsletters-my-periodical-create',
                component: () => import('../views/pages/newsletters/periodicals/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/my-periodicals/:id(\\d+)',
                name: 'newsletters-my-periodical-edit',
                component: () => import('../views/pages/newsletters/periodicals/item.vue'),
                props: { own: true }
            },
            {
                path: '/newsletters/all',
                name: 'all-newsletters',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/list.vue'),
                props: { locked: true }
            },
            {
                path: '/newsletters/newsletters',
                name: 'newsletters-newsletters',
                component: () => import('../views/pages/newsletters/newsletters/list.vue'),
                props: { own: false },
            },
            {
                path: '/newsletters/newsletters/create',
                name: 'newsletters-newsletter-create',
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: false },
            },
            {
                path: '/newsletters/newsletters/:id(\\d+)/statistic',
                name: 'newsletters-newsletter-statistic',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/newsletters/statistic.vue'),
            },
            {
                path: '/newsletters/newsletters/:id(\\d+)',
                name: 'newsletters-newsletter-edit',
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: false },
            },
            {
                path: '/newsletters/mail-lists',
                name: 'newsletters-mail-lists',
                component: () => import('../views/pages/newsletters/mail-lists/list.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/mail-lists/create',
                name: 'newsletters-mail-list-create',
                component: () => import('../views/pages/newsletters/mail-lists/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/mail-lists/:id(\\d+)',
                name: 'newsletters-mail-list-edit',
                component: () => import('../views/pages/newsletters/mail-lists/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/email-lists',
                name: 'newsletters-email-lists',
                component: () => import('../views/pages/newsletters/email-lists/list.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/email-lists/create',
                name: 'newsletters-email-list-create',
                component: () => import('../views/pages/newsletters/email-lists/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/email-lists/:id(\\d+)',
                name: 'newsletters-email-list-edit',
                component: () => import('../views/pages/newsletters/email-lists/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/emails',
                name: 'newsletters-emails',
                component: () => import('../views/pages/newsletters/emails/list.vue')
            },
            {
                path: '/newsletters/emails/create',
                name: 'newsletters-email-create',
                component: () => import('../views/pages/newsletters/emails/item.vue')
            },
            {
                path: '/newsletters/emails/:id(\\d+)',
                name: 'newsletters-email-edit',
                component: () => import('../views/pages/newsletters/emails/item.vue')
            },
            {
                path: '/newsletters/settings',
                name: 'newsletters-settings',
                component: () => import('../views/pages/newsletters/settings/list.vue')
            },
            {
                path: '/newsletters/settings/create',
                name: 'newsletters-setting-create',
                component: () => import('../views/pages/newsletters/settings/item.vue')
            },
            {
                path: '/newsletters/settings/:id(\\d+)',
                name: 'newsletters-setting-edit',
                component: () => import('../views/pages/newsletters/settings/item.vue')
            },
            {
                path: '/newsletters/domains',
                name: 'newsletters-domains',
                component: () => import('../views/pages/newsletters/domains/list.vue')
            },
            {
                path: '/newsletters/domains/create',
                name: 'newsletters-domain-create',
                component: () => import('../views/pages/newsletters/domains/item.vue')
            },
            {
                path: '/newsletters/domains/:id(\\d+)',
                name: 'newsletters-domain-edit',
                component: () => import('../views/pages/newsletters/domains/item.vue')
            },
            {
                path: '/newsletters/senders',
                name: 'newsletters-senders',
                component: () => import('../views/pages/newsletters/senders/list.vue')
            },
            {
                path: '/newsletters/senders/create',
                name: 'newsletters-sender-create',
                component: () => import('../views/pages/newsletters/senders/item.vue')
            },
            {
                path: '/newsletters/senders/:id(\\d+)',
                name: 'newsletters-sender-edit',
                component: () => import('../views/pages/newsletters/senders/item.vue')
            },
            {
                path: '/newsletters/filters',
                name: 'newsletters-filters',
                component: () => import('../views/pages/newsletters/filters/list.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/filters/create',
                name: 'newsletters-filter-create',
                component: () => import('../views/pages/newsletters/filters/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/filters/:id(\\d+)',
                name: 'newsletters-filter-edit',
                component: () => import('../views/pages/newsletters/filters/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/periodicals',
                name: 'newsletters-periodicals',
                component: () => import('../views/pages/newsletters/periodicals/list.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/periodicals/create',
                name: 'newsletters-periodical-create',
                component: () => import('../views/pages/newsletters/periodicals/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/periodicals/:id(\\d+)',
                name: 'newsletters-periodical-edit',
                component: () => import('../views/pages/newsletters/periodicals/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/periodicals/:id(\\d+)/queue-dates',
                name: 'newsletter-queue-dates',
                meta: {
                    authentication_required: true,
                    authorization_required: null
                },
                component: () => import('../views/pages/newsletters/queue-dates/calendar.vue'),
            },
            {
                path: '/newsletters/periodicals/:id(\\d+)/newsletters/create',
                name: 'newsletters-periodical-newsletter-edit',
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: false }
            },
            {
                path: '/newsletters/periodicals/:periodical(\\d+)/queue-dates/:queue(\\d+)/newsletters/create',
                name: 'newsletters-periodical-queue-date-newsletter-edit',
                component: () => import('../views/pages/newsletters/newsletters/item.vue'),
                props: { own: false }
            },
            {
                path: '/interactions/categories/:category(\\d+)/monthly',
                name: 'interaction-category-monthly',
                component: () => import('../views/pages/interactions/categories/monthly.vue')
            },
            {
                path: '/interactions/categories/:category(\\d+)/create',
                name: 'interaction-category-create-interaction',
                component: () => import('../views/pages/interactions/categories/interaction.vue')
            },
            {
                path: '/organizations/organizations',
                name: 'organizations-organizations',
                component: () => import('../views/pages/organization/organizations/list.vue'),
                props: { own: false },
            },
            {
                path: '/organizations/organizations/create',
                name: 'organizations-organization-create',
                component: () => import('../views/pages/organization/organizations/item.vue'),
                props: { own: false },
            },
            {
                path: '/organizations/organizations/:id(\\d+)',
                name: 'organizations-organization-edit',
                component: () => import('../views/pages/organization/organizations/item.vue'),
                props: { own: false },
            },
        ]
    },
    {
        path: '/auth/login',
        name: 'login',
        component: () => import('../views/pages/auth/login.vue')
    },
    {
        path: '/auth/logout',
        name: 'logout',
        component: () => import('../views/pages/auth/logout.vue')
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () => import('../views/pages/auth/register.vue')
    },
    {
        path: '/auth/lock-screen',
        name: 'lock-screen',
        component: () => import('../views/pages/auth/lock-screen.vue')
    },
    {
        path: '/auth/recover-password',
        name: 'recover-password',
        component: () => import('../views/pages/auth/recover-password.vue')
    },
    {
        path: '/auth/reset/:token',
        name: 'reset-password',
        component: () => import('../views/pages/auth/reset-password.vue')
    },
    {
        path: '/auth/confirm-mail',
        name: 'confirm-mail',
        component: () => import('../views/pages/auth/confirm-mail.vue')
    },
    {
        path: '/auth/two-step-verification',
        name: 'two-step-verification',
        component: () => import('../views/pages/auth/two-step-verification.vue')
    },
    {
        path: '/auth/email-verification',
        name: 'email-verification',
        component: () => import('../views/pages/auth/email-verification.vue')
    },
]
